import { combineReducers } from '@reduxjs/toolkit';
import { dashboardSlice } from '@components/Dashboard/dashboardSlice';
import { approvalsSlice } from '@components/Stats/slice/approvalsSlice';
import { rootApi } from '@components/rootApi';

const rootReducer = combineReducers({
  dashboardSlice: dashboardSlice.reducer,
  approvals: approvalsSlice.reducer,
  [rootApi.reducerPath]: rootApi.reducer,
});

export default rootReducer;
